import { Injectable } from '@angular/core';
import { DataService as CoreDataService, ReadObjectTypeInfoModel } from '@barthauer/abc/core/data';
import { Observable } from 'rxjs';
import { OPathFunctions } from '../models/function.model';

@Injectable({
  providedIn: 'root',
})
export class FunctionService {
  public oPathFunctions: OPathFunctions;
  constructor(private coreDataService: CoreDataService) {}
  public createReadFunctionInfo(): Observable<OPathFunctions> {
    const observable$ = new Observable<OPathFunctions>((observer) => {
      const queryFunction: ReadObjectTypeInfoModel = new ReadObjectTypeInfoModel();
      this.coreDataService.executeFunctionsInfoQuery(queryFunction).subscribe((data: ArrayBuffer) => {
        this.oPathFunctions = new OPathFunctions(data);
        observer.next(this.oPathFunctions);
      });
    });

    return observable$;
  }
}
